/* Metabolae ↔ Kaching Bundles sync (port of the live theme's three inline scripts, de-duplicated).
   1. Sale pill (#badge-sale-*) + add-to-cart price follow the selected Kaching bar / variant / selling plan.
   2. "Stock up. Save more." cards mirror Kaching prices, savings, images and selection; their buttons select the
      matching bar and press the main add-to-cart, so subscriptions/discounts go through the widget.
   Without Kaching on the page everything falls back to the theme's own variant-based bars. */
(function () {
  'use strict';
  if (window.__mbKachingSync) return; window.__mbKachingSync = true;

  var moneyFmt = (window.mbMoneyFormat || '${{amount}}');
  function formatMoney(cents) {
    /* Supports every Shopify money format token (with/without decimals; period, comma, space or apostrophe separators) */
    var n = cents / 100, neg = n < 0; n = Math.abs(n);
    function grp(intStr, sep) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
    function fmt(dec, thou, decSep) {
      var f = n.toFixed(dec), parts = f.split('.'), out = grp(parts[0], thou);
      if (dec > 0) out += decSep + parts[1];
      return (neg ? '-' : '') + out;
    }
    var tokens = {
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', ''),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ''),
      amount_with_space_separator: fmt(2, ' ', ','),
      amount_no_decimals_with_space_separator: fmt(0, ' ', ''),
      amount_with_period_and_space_separator: fmt(2, ' ', '.'),
      amount_with_apostrophe_separator: fmt(2, "'", '.'),
      amount_no_decimals_with_apostrophe_separator: fmt(0, "'", '')
    };
    return moneyFmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return tokens[k] !== undefined ? tokens[k] : m; });
  }
  function parseToCents(str) {
    var s = String(str || '').replace(/[^\d.,']/g, '').replace(/'/g, ''); if (!s) return 0;
    var lastComma = s.lastIndexOf(','), lastDot = s.lastIndexOf('.');
    if (lastComma > lastDot) { s = s.replace(/\./g, '').replace(/,(\d{1,2})$/, '.$1').replace(/,/g, ''); }
    else { s = s.replace(/,/g, ''); if ((s.match(/\./g) || []).length > 1) s = s.replace(/\.(?=.*\.)/g, ''); }
    return Math.round(parseFloat(s) * 100) || 0;
  }
  function variantsFor(section) {
    var tag = section.querySelector('script[data-mb-variants]'); if (!tag) return {};
    var map = {}; try { JSON.parse(tag.textContent).forEach(function (v) { map[v.id] = v; }); } catch (e) {}
    return map;
  }

  /* ---------- 1. Sale pill + ATC price ---------- */
  function initBuyBox(section) {
    var wrap = section.querySelector('.bsw'); var btn = section.querySelector('.product-form__submit');
    if (!wrap) return;
    var priceEl = wrap.querySelector('[data-badge-price]'), compareEl = wrap.querySelector('[data-badge-compare]'), pillEl = wrap.querySelector('[data-badge-pill]'), pctEl = wrap.querySelector('[data-badge-pct]');
    var atcPrice = btn && btn.querySelector('.mb-atc-btn-price'), atcCmp = btn && btn.querySelector('.mb-atc-btn-compare');
    var variantMap = variantsFor(section);

    function render(priceCents, compareCents) {
      if (priceEl) priceEl.textContent = formatMoney(priceCents);
      if (atcPrice) atcPrice.textContent = formatMoney(priceCents);
      var onSale = compareCents && compareCents > priceCents;
      if (compareEl) { compareEl.textContent = onSale ? formatMoney(compareCents) : ''; compareEl.classList.toggle('bsw__compare--hidden', !onSale); }
      if (atcCmp) { atcCmp.textContent = onSale ? formatMoney(compareCents) : ''; atcCmp.hidden = !onSale; }
      if (pillEl) { pillEl.classList.toggle('bsw__pill--hidden', !onSale); if (pctEl && onSale) pctEl.textContent = Math.round((compareCents - priceCents) / compareCents * 100) + '%'; }
    }
    function fromVariant(id) { var v = variantMap[parseInt(id, 10)]; if (v) render(v.price, v.compare_at_price || 0); }

    /* variant / selling plan changes */
    document.addEventListener('variant:changed', function (e) { if (e.detail && e.detail.variant) render(e.detail.variant.price, e.detail.variant.compare_at_price || 0); });
    document.addEventListener('change', function (e) { var el = e.target; if (!el) return; if (el.name === 'id') fromVariant(el.value); if (el.name === 'selling_plan') setTimeout(readKaching, 250); });
    var hidden = section.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (hidden) { var last = hidden.value; setInterval(function () { if (hidden.value !== last) { last = hidden.value; fromVariant(last); } }, 200); }

    /* Kaching: follow the selected bar's rendered prices */
    var kTimer = null, kLastP = -1, kLastC = -1;
    function activeKaching() {
      var wrapK = document.querySelector('.kaching-bundles');
      if (wrapK) {
        var checked = wrapK.querySelector('input[type="radio"]:checked');
        if (checked) { var row = checked.parentElement; while (row && row !== wrapK) { var bp = row.querySelector('.kaching-bundles__bar-price'), bf = row.querySelector('.kaching-bundles__bar-full-price'); if (bp && bf) return { p: bp, f: bf }; row = row.parentElement; } }
        var sel = wrapK.querySelector('.kaching-bundles__bar--selected');
        if (sel) { var sp = sel.querySelector('.kaching-bundles__bar-price'), sf = sel.querySelector('.kaching-bundles__bar-full-price'); if (sp && sf) return { p: sp, f: sf }; }
      }
      return { p: document.querySelector('.kaching-bundles__bar-price'), f: document.querySelector('.kaching-bundles__bar-full-price') };
    }
    function readKaching() {
      if (kTimer) clearTimeout(kTimer);
      kTimer = setTimeout(function () {
        var els = activeKaching(); if (!els.p || !els.f) return;
        var pc = parseToCents(els.p.innerText), cc = parseToCents(els.f.innerText);
        if (pc <= 0 || cc <= 0 || (pc === kLastP && cc === kLastC)) return;
        kLastP = pc; kLastC = cc; render(pc, cc);
      }, 50);
    }
    function attach() {
      var bp = document.querySelector('.kaching-bundles__bar-price'), bf = document.querySelector('.kaching-bundles__bar-full-price');
      if (!bp || !bf) return false;
      readKaching();
      var root = document.querySelector('.kaching-bundles') || section;
      new MutationObserver(readKaching).observe(root, { subtree: true, childList: true, characterData: true, attributes: true });
      return true;
    }
    if (!attach()) { var n = 0, poll = setInterval(function () { if (attach() || ++n >= 50) clearInterval(poll); }, 100); }
    ['kaching:price:updated', 'kaching:bundle:selected', 'kaching:subscription:changed', 'kaching:subscription:toggled', 'kaching:autoship:changed', 'kaching:selling_plan:changed'].forEach(function (ev) { document.addEventListener(ev, readKaching); });
  }

  /* ---------- 2. Pricing cards ---------- */
  function kachingBars() { return document.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar'); }
  window.mbSyncToKaching = function (idx) {
    var bars = kachingBars(); if (!bars[idx]) return false;
    var t = bars[idx].querySelector('.kaching-bundles__bar-main, input[type="radio"], label'); if (t) t.click();
    return true;
  };
  function activeKachingIndex() {
    var wrapK = document.querySelector('.kaching-bundles'); if (!wrapK) return -1;
    var bars = Array.prototype.slice.call(wrapK.querySelectorAll('.kaching-bundles__bars > .kaching-bundles__bar'));
    var checked = wrapK.querySelector('input[type="radio"]:checked');
    if (checked) { var row = checked.closest('.kaching-bundles__bar'); var i = bars.indexOf(row); if (i !== -1) return i; }
    var sel = wrapK.querySelector('.kaching-bundles__bar--selected'); return sel ? bars.indexOf(sel) : -1;
  }
  function initPricing(section) {
    var cards = section.querySelectorAll('[data-pc-index]');
    if (!cards.length) return;
    function sync() {
      var bars = kachingBars(); if (!bars.length) return;
      bars.forEach(function (bar, idx) {
        var price = bar.querySelector('.kaching-bundles__bar-price'), full = bar.querySelector('.kaching-bundles__bar-full-price'), sub = bar.querySelector('.kaching-bundles__bar-subtitle'), img = bar.querySelector('.kaching-bundles__bar-image');
        section.querySelectorAll('[data-pc-index="' + idx + '"]').forEach(function (card) {
          if (price) card.querySelectorAll('[data-pc-price]').forEach(function (e) { e.textContent = price.textContent.trim(); });
          if (full) card.querySelectorAll('[data-pc-compare]').forEach(function (e) { e.textContent = full.textContent.trim(); });
          if (sub) card.querySelectorAll('[data-pc-save]').forEach(function (e) { e.textContent = sub.textContent.trim(); });
          if (img && img.src) card.querySelectorAll('[data-pc-img]').forEach(function (e) { if (e.getAttribute('data-custom-image') !== 'true') { if (e.tagName === 'IMG') e.src = img.src; else { var ni = document.createElement('img'); ni.src = img.src; ni.alt = ''; e.replaceWith(ni); } } });
        });
      });
      var a = activeKachingIndex();
      if (a !== -1) { cards.forEach(function (c) { c.classList.toggle('active', +c.dataset.pcIndex === a); c.classList.toggle('is-selected', +c.dataset.pcIndex === a); });
        var sel = section.querySelector('.pricing-row-item[data-pc-index="' + a + '"] [data-pc-price]'); var cta = section.querySelector('[data-pc-mobile-price]'); if (sel && cta) cta.textContent = sel.textContent; }
    }
    /* buttons → select the Kaching bar, then press the main add-to-cart */
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pc-add]'); var row = e.target.closest('.pricing-row-item[data-pc-index]');
      if (btn && kachingBars().length) {
        e.preventDefault(); var idx = +btn.closest('[data-pc-index]').dataset.pcIndex; window.mbSyncToKaching(idx);
        var main = document.querySelector('.mb-atc-btn, .product-form__submit'); if (main) setTimeout(function () { main.click(); }, 60);
      } else if (row && !btn && kachingBars().length) { window.mbSyncToKaching(+row.dataset.pcIndex); }
    }, true);
    var tries = 0; (function check() { if (kachingBars().length) { sync(); new MutationObserver(sync).observe(document.querySelector('.kaching-bundles__bars'), { childList: true, subtree: true, attributes: true, characterData: true }); } else if (tries++ < 40) setTimeout(check, 200); })();
  }

  /* Kaching installed as an APP EMBED (not an app block): the embed injects <kaching-bundle> on its own.
     Hide the theme's fallback bars and make sure the widget sits in the bundle slot above the add-to-cart button. */
  function initEmbed(section) {
    var mount = section.querySelector('[data-mb-kaching-mount]');
    var btn = section.querySelector('.product-form__submit');
    function adopt() {
      var k = document.querySelector('kaching-bundle, kaching-bundles-block, .kaching-bundles');
      if (!k) return false;
      section.classList.add('mb-has-kaching');
      var node = k.closest('kaching-bundle') || k;
      if (mount && !mount.contains(node) && !node.closest('.mb-app-block')) {
        var inSection = section.contains(node);
        var afterBtn = btn && (btn.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING);
        if (!inSection || afterBtn) mount.appendChild(node);
      }
      return true;
    }
    if (!adopt()) {
      var n = 0, poll = setInterval(function () { if (adopt() || ++n >= 100) clearInterval(poll); }, 100);
      new MutationObserver(function () { if (adopt()) { /* keep observing: embed may re-render */ } }).observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    document.querySelectorAll('[data-mb-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-mb-buybox]').forEach(initEmbed);
    document.querySelectorAll('[data-mb-pricing]').forEach(initPricing);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
